/**
 * Labstep
 *
 * @module grid/BatchCreateResourceItems/components/ColumnHeader/DateHeader/ContextMenu
 * @desc Entity Batch Create Resource Items Context Menu
 */

import { format as formatFns, parse } from 'date-fns';
import {
  useDataGridContext,
  useGridBatchCreateResourceItemsServiceFromContext,
} from 'labstep-web/contexts/grid/hook';
import { Dropdown } from 'labstep-web/core/Dropdown';
import { DropdownPortal } from 'labstep-web/core/Dropdown/Portal';
import { useBatchCreateItemContext } from 'labstep-web/grid/BatchCreateResourceItems/context';
import {
  ENTITY_DATE_FORMATS,
  ENTITY_DATETIME_FORMATS,
} from 'labstep-web/grid/BatchCreateResourceItems/services/grid-batch-create-resource-items-service';
import type React from 'react';
import type { BatchCreateResourceItemsDateHeaderContextMenuProps } from './types';
export const BatchCreateResourceItemsDateHeaderContextMenu: React.FC<
  BatchCreateResourceItemsDateHeaderContextMenuProps
> = ({ column, trigger, resource, data, setData, isDatetime }) => {
  const formats = isDatetime
    ? ENTITY_DATETIME_FORMATS
    : ENTITY_DATE_FORMATS;
  const ctx = useBatchCreateItemContext();
  const gridBatchCreateResourceItemsService =
    useGridBatchCreateResourceItemsServiceFromContext();
  const { agGrid } = useDataGridContext();

  if (!ctx || !agGrid || !gridBatchCreateResourceItemsService) {
    return trigger;
  }

  const { dateFormats, setDateFormats } = ctx;

  const dropdownItems: React.ReactNode[] = formats.map((format) => {
    return (
      <Dropdown.Item
        key={format}
        onClick={() => {
          const oldFormat =
            dateFormats[column.getColId()] || formats[0];

          const newData = data.map((row) => {
            const rowAtColId = row[column.getColId()];
            const newRow = { ...row };
            if (rowAtColId?.date) {
              const date = parse(
                rowAtColId.date,
                oldFormat,
                new Date(),
              );
              const formatedDate = formatFns(date, format);
              newRow[column.getColId()] = {
                ...newRow,
                date: formatedDate,
              };
            }
            return newRow;
          });

          setData(newData);

          setDateFormats({
            ...dateFormats,
            [column.getColId()]: format,
          });

          gridBatchCreateResourceItemsService.recreateColumnDefs(
            newData,
            setData,
            resource,
            { ...dateFormats, [column.getColId()]: format },
          );

          agGrid.api.refreshCells({
            columns: [column.getColId()],
            force: true,
            suppressFlash: true,
          });
        }}
      >
        {format}
      </Dropdown.Item>
    );
  });

  return dropdownItems.length ? (
    <DropdownPortal closeOnChange trigger={trigger}>
      {dropdownItems}
    </DropdownPortal>
  ) : (
    trigger
  );
};
